import React from "react"
import { Helmet } from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        image
        twitterUsername
        url
      }
    }
  }
`

export const Seo = ({ description, keywords, title, image, url, author }) => {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const siteUrl = data.site.siteMetadata.url.replace(/\/$/, "")
        const twitterUser = data.site.siteMetadata.twitterUsername
        const metaDescription = description || data.site.siteMetadata.description
        const metaTitle = title
          ? `${title} · ${data.site.siteMetadata.title}`
          : data.site.siteMetadata.title
        const metaAuthor = author || data.site.siteMetadata.author
        const metaUrl = url || siteUrl
        const metaImage = image
          ? image.startsWith("http")
            ? image
            : `${siteUrl}${image}`
          : data.site.siteMetadata.image
        const metaKeywords = keywords || ["gatsby blog", "khaled el hamzi", ".net"]
        return (
          <Helmet
            htmlAttributes={{ lang: "sv" }}
            title={metaTitle}
            meta={[
              { name: "description", content: metaDescription },
              { name: "author", content: metaAuthor },
              { property: "og:title", content: metaTitle },
              { property: "og:description", content: metaDescription },
              { property: "og:type", content: "website" },
              { property: "og:image", content: metaImage },
              { property: "og:url", content: metaUrl },
              { name: "twitter:card", content: "summary_large_image" },
              { name: "twitter:creator", content: twitterUser },
              { name: "twitter:title", content: metaTitle },
              { name: "twitter:description", content: metaDescription },
              { name: "twitter:image", content: metaImage },
            ].concat(
              metaKeywords.length
                ? { name: "keywords", content: metaKeywords.join(", ") }
                : []
            )}
          />
        )
      }}
    />
  )
}
